import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { equals } from "ramda";
import clsx from "clsx";

import SidebarTreeItemLabel from "./SidebarTreeItemLabel";
import { TreeItem } from "@mui/x-tree-view/TreeItem";

const useStyles = makeStyles(theme => ({
  approved: {
    color: theme.palette.approved,
  },

  header: {
    fontSize: "1.6rem",
    fontWeight: "inherit",
  },

  pending: {
    color: theme.palette.primary.brandPrimary,
  },

  rejected: {
    color: theme.palette.rejected,
  },

  // x-tree-view v7 applies the `.Mui-selected` state class to the content
  // element, so selected styling targets `content` (not the item root).
  content: {
    "&.Mui-selected": {
      fontWeight: theme.typography.fontWeightBold,
    },
  },

  contentApproved: {
    "&.Mui-selected, &.Mui-selected:hover": {
      backgroundColor: theme.palette.primary.green.light,
    },
  },

  contentRejected: {
    "&.Mui-selected, &.Mui-selected:hover": {
      backgroundColor: theme.palette.primary.red.light,
    },
  },
}));

const SidebarTreeItem = props => {
  const classes = useStyles();
  const {
    count,
    nestedTree,
    icon,
    isModule,
    onClick,
    label,
    nodeId,
    nodeType,
    tooltipLabel,
    variant,
    collapseIcon,
    expandIcon,
    onLabelClick,
    ...otherProps
  } = props;

  // x-tree-view v7 sets per-item expand/collapse icons via slots (component
  // types); default icons come from the SimpleTreeView slots in OrganizeSidebar.
  const iconSlots = {};
  if (expandIcon) iconSlots.expandIcon = () => expandIcon;
  if (collapseIcon) iconSlots.collapseIcon = () => collapseIcon;

  const getTypographyProps = type => {
    switch (type) {
      case "root":
        return { classes: { root: classes.header } };
      default:
        // return { classes: { root: classes.treeItem } };
        return undefined;
    }
  };

  return (
    <TreeItem
      itemId={nodeId}
      // onClick={onClick}
      onClick={onLabelClick}
      classes={{
        content: clsx(classes.content, {
          [classes.contentApproved]: equals(variant, "approved"),
          [classes.contentRejected]: equals(variant, "rejected"),
        }),
        label: clsx(classes.label, {
          [classes.approved]: equals(variant, "approved"),
          [classes.pending]: equals(variant, "pending"),
          [classes.rejected]: equals(variant, "rejected"),
        }),
      }}
      slots={iconSlots}
      label={
        <SidebarTreeItemLabel
          tooltipLabel={tooltipLabel}
          labelText={label}
          icon={icon}
          TypographyProps={getTypographyProps(nodeType)}
        />
      }
      {...otherProps}
    >
      {nestedTree}
    </TreeItem>
  );
};

export default SidebarTreeItem;
